define('taoQtiItem/qtiXmlRenderer/renderers/interactions/ChoiceInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'choiceInteraction',
        template : tpl
    };
});
